import client from "../Client/HttpClient";
import { IEnrollmentChargesModel } from "@/interfaces/modules";

const ApiPath = "EnrollmentCharges";

export default {
    GetEnrollmentCharges: (data: IEnrollmentChargesModel): Promise<IEnrollmentChargesModel[]> => client.get(`${ApiPath}/byEnrollment/${data.EnrollmentId}`),
    GetEnrollmentChargeById: (data: IEnrollmentChargesModel): Promise<IEnrollmentChargesModel> => client.get(`${ApiPath}/${data.Id}`),
    PostEnrollmentCharge: (data: IEnrollmentChargesModel): Promise<IEnrollmentChargesModel> => client.post(`${ApiPath}`, data),
};
